export default {
  ComponentGroupList: () => import('@/views/componentGroup/listPage/ComponentGroupList'),
}